'use strict';

module.exports = [
    function () {

        return {
            restrict: 'E',
            template: '<div class="rm-side-menu" ng-transclude></div>',
            replace: true,
            transclude: true,
            link: function (scope, element, attributes) {

            }
        };
    }
];

